import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Market } from '@app/model/payment-request/payment-request.dto';
import { SERVER_EXTERNAL_BASE_URL } from 'src/environments/environment';

export interface ExternalOrderCreationResponse {
  checkoutToken: string;
  market: Market;
}

@Injectable({
  providedIn: 'root',
})
export class KustomService {
  constructor(private http: HttpClient) {}

  private readonly httpReqOptions = { withCredentials: true };

  getOrCreateOrder(
    orderId: string,
    externalMerchantId: string,
    paymentMethod: string,
    confirmationUrl: string
  ): Promise<ExternalOrderCreationResponse> {
    let params = new HttpParams();

    if (orderId) {
      params = params.append('orderId', orderId);
    }

    if (externalMerchantId) {
      params = params.append('externalMerchantId', externalMerchantId);
    }

    if (paymentMethod) {
      params = params.append('paymentMethod', paymentMethod);
    }

    if (confirmationUrl) {
      params = params.append('confirmationUrl', confirmationUrl);
    }

    return this.http
      .get<ExternalOrderCreationResponse>(
        `${SERVER_EXTERNAL_BASE_URL}/getOrder`,
        {
          ...this.httpReqOptions,
          params: params,
        }
      )
      .toPromise();
  }
}
